<template>
    <v-container>
        <div v-if="hasPermission('MIETSPIEGEL_BACKEND_WRITE_BERECHNUNGSVORLAGE')" class="d-flex justify-left my-3">
            <v-btn v-on:click="save" outlined large color="indigo" aria-labelled-by="Speichern"><span class="black--text subtitle-1">Speichern</span></v-btn>
        </div>
        <div class="my-3">
            <h1 class="uiTitle header">
                Wohnfläche in m²
            </h1>
        </div>
        <div class="d-flex justify-center">
            <v-text-field v-model="tet" id="wohnflaeche-input" @keypress="checkNumber($event)" reverse label="Wohnfläche zwischen 20 m² und 160 m² eingeben" autofocus></v-text-field>
        </div>
        <p class="validationError" role="alert" v-if="error">
            <v-icon style="color:#c50517">mdi-alert</v-icon><strong v-text="$t('wohnflaeche.' + errorText)"></strong>
        </p>
        <!-- BUTTON SECTION -->
        <div class="d-flex justify-center my-3">
            <v-btn v-on:click="next" outlined large color="indigo" aria-labelled-by="Weiter"><span class="black--text subtitle-1">Weiter</span></v-btn>
        </div>
        <!-- INFO SECTION -->
        <div>
            <v-card class="d-flex justify-center mt-6" outlined color="indigo" hover>
                <v-expansion-panels>
                    <v-expansion-panel ref="infoPanel">
                        <v-expansion-panel-header @click="changedExpansion" v-if="expanded" aria-label="Info-Bereich Schließen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-header @click="changedExpansion" v-else aria-label="Info-Bereich Öffnen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <h3>Wohnfläche</h3><br/>
                            <p>Bitte beachten Sie, dass der Mietspiegel nur für Wohnungen mit einer Wohnfläche zwischen 20 und 160 m² anwendbar ist. Es ist möglich, bis zu drei Nachkommastellen anzugeben.</p>
                            <h3>Grundpreis der monatlichen Nettomiete</h3><br/>
                            <p>Der für die Wohnung zutreffende Grundpreis (vergleiche Druckversion der Ergebnisseite) der Nettomiete in Euro pro m² und Monat wird aus der Wohnfläche und dem Baujahr ermittelt. Dieser Grundpreis ist nicht zu verwechseln mit der durchschnittlichen ortsüblichen Miete. Die durchschnittliche ortsübliche Miete pro m² und Monat ergibt sich erst zusammen mit den Zu- und Abschlägen und gegebenenfalls nach Berücksichtigung der Betriebskosten.</p>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
        </div>
    </v-container>
</template>

<script>
    import {Component, Vue} from 'vue-property-decorator';
    import { EventBus } from '../eventbus';
    import { createNamespacedHelpers } from 'vuex';

    const { mapMutations } = createNamespacedHelpers('berechnung')
    const { mapGetters } = createNamespacedHelpers('user')

    @Component({
        computed: { ...mapGetters(['hasPermission'])},
        methods: {
            ...mapMutations(['SET_WOHNFLAECHE'])
        }
    })
    export default class Wohnflaeche extends Vue {

        data() {
            return {
                index: 2,
                error: false,
                tet: this.convertToGermanNumber(this.$store.state.berechnung.wohnflaeche),
                expanded: false,
                errorText: "outOfRange"
            };
        }

        changedExpansion(event){
            this.expanded = !this.expanded
            event.currentTarget.setAttribute('aria-expanded', this.expanded)
        }

        checkForm() {
            this.error = false;
            // Convert german number format to international
            var number = this.convertToInternationalNumber(this.tet);
            if(isNaN(number) || number < 20 || number > 160 || this.hasTooManyDecimalPlaces(number)) {
                this.error = true;
            }

            return !this.error;
        }

        checkNumber(event){
            let key = event.key
            if(key != '.' && key != ',' && isNaN(key)) {
                event.preventDefault()
            }
            let before = event.target.value
            let start = event.target.selectionStart
            let result = before.slice(0, start) + event.key + before.slice(start)
            if(this.hasTooManyDecimalPlaces(this.convertToInternationalNumber(result))){
                event.preventDefault()
            }
        }

        hasTooManyDecimalPlaces(text){
            if(text.split('.')[1]){
                return text.split('.')[1].length > 3
            }
            return false
        }

        convertToGermanNumber(text) {
            if(!isNaN(text)) {
                return text.toString().replace('.', ',');
            }
            return '';
        }

        convertToInternationalNumber(text) {
            return text.replace(',', '.');
        }

        mounted() {
            EventBus.$emit('scroll', this.$data.index)
            this.$refs.infoPanel.$el.firstChild.setAttribute('aria-expanded', false)
        }

        save() {
            EventBus.$emit('getSaveData', this.index)
        }

        next() {
            console.log(this.$data.tet)
            if(this.checkForm()) {
                this.SET_WOHNFLAECHE(this.convertToInternationalNumber(this.$data.tet))
                this.$router.push('baujahr')
            }
            if(this.error){
                let alert = document.querySelector('.validationError')
                alert.removeAttribute('role')
                alert.setAttribute("role", "alert")
            }
        }
    }
</script>
